export default "__VITE_ASSET__b6496105__"